import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Works() {
  return (
    <div className="bg-black text-white">
      <Header />

      <section className="max-w-7xl mx-auto px-6 lg:px-16 py-20">
        {/* HEADER */}
        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div>
            <h1 className="text-6xl md:text-7xl uppercase font-bold">Works</h1>
            <div className="w-20 h-1 bg-lime-400 mt-8"></div>
          </div>

          <div>
            <p className="text-gray-400 leading-8 max-w-md">
              Super Strength Cables specializes in manufacturing premium control
              cable systems for motorcycles, automobiles, industrial machinery,
              agricultural equipment, and custom engineering applications.
            </p>
          </div>
        </div>

        {/* FEATURED WORK */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <img
            src="https://images.unsplash.com/photo-1524591652733-73fa1ae7b5ee?auto=format&fit=crop&w=1400&q=80"
            className="w-full h-[520px] object-cover object-bottom rounded-2xl border border-zinc-800"
            alt="Industrial Cable"
          />

          <div className="space-y-6">
            <p className="uppercase tracking-[4px] text-lime-400 text-xs font-bold">
              Featured Project
            </p>

            <h2 className="text-4xl md:text-5xl font-black uppercase">
              Heavy Duty Control Cable Assembly
            </h2>

            <p className="text-gray-400 leading-7">
              Custom-engineered throttle, clutch, and brake cable systems
              designed for demanding applications.
            </p>

            <ul className="text-gray-300 space-y-2 text-sm">
              <li>✔ Custom Cable Manufacturing</li>
              <li>⚙ High-Tensile Stainless Steel Inner Wire</li>
              <li>🛡 Heavy-Duty PVC & Nylon Outer Casing</li>
              <li>⏳ Production Time: 3–5 Weeks</li>
              <li>🚚 Bulk Supply for OEM & Aftermarket Applications</li>
            </ul>
          </div>
        </div>

        {/* OTHER PROJECTS */}
        <div className="mt-24">
          <h3 className="text-3xl font-bold text-center mb-12">
            Other Cable Projects
          </h3>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">
                Motorcycle Throttle Cables
              </h4>
              <p className="text-gray-400">
                Precision-engineered throttle cable systems.
              </p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">
                Automotive Control Cables
              </h4>
              <p className="text-gray-400">
                Accelerator and clutch cable systems.
              </p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">
                Industrial Cable Systems
              </h4>
              <p className="text-gray-400">
                Heavy-duty industrial cable solutions.
              </p>
            </div>
          </div>
        </div>

        {/* INDUSTRIES */}
        <div className="mt-24">
          <h3 className="text-3xl font-bold text-center mb-12">
            Industries We Serve
          </h3>

          <div className="grid md:grid-cols-4 gap-6 text-center">
            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold">Motorcycles</h4>
              <p className="text-gray-400 mt-2">Brake & throttle cables</p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold">Automotive</h4>
              <p className="text-gray-400 mt-2">Transmission systems</p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold">Agriculture</h4>
              <p className="text-gray-400 mt-2">Tractor machinery cables</p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold">Industrial</h4>
              <p className="text-gray-400 mt-2">Heavy-duty systems</p>
            </div>
          </div>
        </div>

        {/* SPECIFICATIONS */}
        <div className="mt-24 max-w-5xl mx-auto">
          <h3 className="text-3xl font-bold text-center mb-12">
            Project Specifications
          </h3>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-4">Materials</h4>
              <ul className="text-gray-400 space-y-2">
                <li>Stainless Steel Wire</li>
                <li>Galvanized Steel</li>
                <li>Nylon Liners</li>
                <li>PVC Casings</li>
              </ul>
            </div>

            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-4">Features</h4>
              <ul className="text-gray-400 space-y-2">
                <li>Smooth Operation</li>
                <li>Low Friction</li>
                <li>Weather Resistant</li>
                <li>Long Life</li>
              </ul>
            </div>
          </div>
        </div>

        {/* MANUFACTURING */}
        <div className="mt-24">
          <h3 className="text-3xl font-bold text-center mb-12">
            Manufacturing Capabilities
          </h3>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">Custom Design</h4>
              <p className="text-gray-400">
                Tailor-made cable systems for clients.
              </p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">OEM Production</h4>
              <p className="text-gray-400">
                Large-scale manufacturing support.
              </p>
            </div>

            <div className="bg-zinc-900 p-6 rounded-xl">
              <h4 className="text-lime-400 font-bold mb-3">Quality Testing</h4>
              <p className="text-gray-400">Load and durability testing.</p>
            </div>
          </div>
        </div>

        {/* ACHIEVEMENTS */}
        <div className="mt-24">
          <h3 className="text-3xl font-bold text-center mb-12">
            Our Achievements
          </h3>

          <div className="grid md:grid-cols-4 gap-6 text-center">
            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-4xl font-black text-lime-400">1986</h4>
              <p className="text-gray-400 mt-2">Founded</p>
            </div>

            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-4xl font-black text-lime-400">256</h4>
              <p className="text-gray-400 mt-2">Projects</p>
            </div>

            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-4xl font-black text-lime-400">100+</h4>
              <p className="text-gray-400 mt-2">Clients</p>
            </div>

            <div className="bg-zinc-900 p-8 rounded-xl">
              <h4 className="text-4xl font-black text-lime-400">16</h4>
              <p className="text-gray-400 mt-2">Awards</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-24 bg-zinc-900 rounded-2xl p-12 text-center">
          <h3 className="text-4xl font-black uppercase">
            Need Custom Cable Solutions?
          </h3>

          <p className="text-gray-400 mt-6 max-w-2xl mx-auto">
            Partner with us for high-performance cable systems.
          </p>

          <a
            href="/contact"
            className="inline-block mt-8 bg-lime-400 text-black px-8 py-4 rounded-lg font-bold hover:bg-lime-300 transition"
          >
            Contact Us
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}

// import Header from "../components/Header";
// import Footer from "../components/Footer";

// export default function Works() {
//   return (
//     <div className="bg-black text-white">
//       <Header />

//       <main className="max-w-7xl mx-auto px-6 lg:px-16 py-24 space-y-28">
//         {/* HERO */}
//         <section className="text-center space-y-6">
//           <h1 className="text-6xl md:text-8xl font-black uppercase">
//             Bike Cable Works
//           </h1>

//           <div className="w-24 h-[2px] bg-lime-400 mx-auto"></div>

//           <p className="text-gray-400 max-w-2xl mx-auto text-lg leading-7">
//             We manufacture high-performance motorcycle control cables including
//             throttle, clutch, and brake cables for all bike segments.
//           </p>
//         </section>

//         {/* FEATURED PROJECT */}
//         <section className="grid md:grid-cols-2 gap-12 items-center">
//           <img
//             src="https://images.unsplash.com/photo-1524591652733-73fa1ae7b5ee?auto=format&fit=crop&w=1400&q=80"
//             alt="Motorcycle Cable Assembly"
//             className="w-full h-[520px] object-cover rounded-2xl border border-zinc-800"
//           />

//           <div className="space-y-6">
//             <p className="text-lime-400 uppercase tracking-[4px] text-xs">
//               Featured Bike Cable Project
//             </p>

//             <h2 className="text-4xl font-bold uppercase leading-tight">
//               High Precision Motorcycle Control Cable Kit
//             </h2>

//             <p className="text-gray-400 leading-7">
//               Designed for smooth throttle response, reliable braking, and
//               long-lasting clutch performance for all types of motorcycles.
//             </p>

//             <ul className="text-gray-300 space-y-2 text-sm">
//               <li>✔ Motorcycle Throttle Cable Assembly</li>
//               <li>✔ Bike Clutch Cable System</li>
//               <li>✔ High Strength Steel Inner Wire</li>
//               <li>✔ Weather Resistant Outer Casing</li>
//               <li>✔ OEM Bike Compatibility</li>
//             </ul>
//           </div>
//         </section>

//         {/* PROJECT GRID */}
//         <section className="space-y-10">
//           <h3 className="text-3xl font-bold text-center">
//             Bike Cable Manufacturing Projects
//           </h3>

//           <div className="grid md:grid-cols-3 gap-6">
//             {/* 1 */}
//             <div className="rounded-2xl overflow-hidden border border-zinc-800 group">
//               <img
//                 src="https://images.unsplash.com/photo-1524591652733-73fa1ae7b5ee?auto=format&fit=crop&w=1200&q=80"
//                 alt="Bike Throttle Cable"
//                 className="h-56 w-full object-cover group-hover:scale-105 transition duration-500"
//               />
//               <div className="p-5">
//                 <h4 className="text-lime-400 font-bold">
//                   Bike Throttle Cable System
//                 </h4>
//                 <p className="text-gray-400 text-sm mt-2">
//                   Smooth acceleration control for motorcycles.
//                 </p>
//               </div>
//             </div>

//             {/* 2 */}
//             <div className="rounded-2xl overflow-hidden border border-zinc-800 group">
//               <img
//                 src="https://images.unsplash.com/photo-1558980394-d5c4b6a5a2a2?auto=format&fit=crop&w=1200&q=80"
//                 alt="Bike Brake Cable"
//                 className="h-56 w-full object-cover group-hover:scale-105 transition duration-500"
//               />
//               <div className="p-5">
//                 <h4 className="text-lime-400 font-bold">
//                   Motorcycle Brake Cable
//                 </h4>
//                 <p className="text-gray-400 text-sm mt-2">
//                   Reliable braking response for safe riding.
//                 </p>
//               </div>
//             </div>

//             {/* 3 */}
//             <div className="rounded-2xl overflow-hidden border border-zinc-800 group">
//               <img
//                 src="https://images.unsplash.com/photo-1609630875171-b1321377ee65?auto=format&fit=crop&w=1200&q=80"
//                 alt="Bike Engine Cable"
//                 className="h-56 w-full object-cover group-hover:scale-105 transition duration-500"
//               />
//               <div className="p-5">
//                 <h4 className="text-lime-400 font-bold">
//                   Bike Engine Control Cable
//                 </h4>
//                 <p className="text-gray-400 text-sm mt-2">
//                   Smooth engine response control system.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* CTA */}
//         <section className="text-center bg-zinc-900 p-16 rounded-2xl space-y-6">
//           <h3 className="text-4xl font-black uppercase">
//             Need Bike Cable Manufacturing?
//           </h3>

//           <p className="text-gray-400 max-w-xl mx-auto">
//             We specialize in custom motorcycle throttle, brake, and clutch cable
//             manufacturing.
//           </p>

//           <a
//             href="/contact"
//             className="inline-block bg-lime-400 text-black px-8 py-4 rounded-lg font-bold hover:bg-lime-300 transition"
//           >
//             Contact Us
//           </a>
//         </section>
//       </main>

//       <Footer />
//     </div>
//   );
// }
